import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../../lib/api';
import { useStore } from '../../context/StoreContext';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';

export const WalkIn = () => {
  const navigate = useNavigate();
  const { currentEvent, staffName } = useStore();
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    booked_at_padua: false,
    planning_wedding: false,
    tour_status: 'Never Toured'
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleNext = (e) => {
    e.preventDefault();
    if (step === 1 && formData.first_name && formData.last_name) {
      setStep(2);
    }
  };

  const handleSubmit = async () => {
    if (!currentEvent || !currentEvent.event_id) {
      alert("Event ID missing. Ensure the local database is initialized.");
      return;
    }
    
    const relationshipType = formData.booked_at_padua 
      ? 'Booked Couple' 
      : formData.planning_wedding 
        ? 'Prospective Couple' 
        : 'Guest / Other';
        
    await api.addWalkIn(
      currentEvent.event_id,
      {
        first_name: formData.first_name,
        last_name: formData.last_name,
        email: formData.email,
        phone: formData.phone
      },
      {
        relationship_type: relationshipType,
        booked_at_padua: formData.booked_at_padua,
        tour_status: formData.tour_status
      },
      staffName
    );
    navigate('/');
  };

  return (
    <div className="max-w-2xl mx-auto animate-in fade-in slide-in-from-bottom-4">
      <h1 className="text-3xl font-cinzel text-padua-green mb-6 text-center">Register Walk-In</h1>
      
      <Card className="p-8">
        {step === 1 ? (
          <form onSubmit={handleNext} className="space-y-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">First Name *</label>
                <input required type="text" name="first_name" value={formData.first_name} onChange={handleChange} className="w-full p-4 border border-gray-300 rounded-xl focus:ring-padua-gold focus:border-padua-gold bg-white" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Last Name *</label>
                <input required type="text" name="last_name" value={formData.last_name} onChange={handleChange} className="w-full p-4 border border-gray-300 rounded-xl focus:ring-padua-gold focus:border-padua-gold bg-white" />
              </div>
            </div>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                <input type="email" name="email" value={formData.email} onChange={handleChange} className="w-full p-4 border border-gray-300 rounded-xl focus:ring-padua-gold focus:border-padua-gold bg-white" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
                <input type="tel" name="phone" value={formData.phone} onChange={handleChange} className="w-full p-4 border border-gray-300 rounded-xl focus:ring-padua-gold focus:border-padua-gold bg-white" />
              </div>
            </div>
            
            <Button type="submit" variant="large" className="w-full mt-8">Continue</Button>
          </form>
        ) : (
          <div className="space-y-8 text-center">
            <div className="space-y-4">
              <h3 className="text-xl font-medium text-padua-green">Are they currently booked with Padua?</h3>
              <div className="flex gap-4 justify-center">
                <Button variant={formData.booked_at_padua ? 'primary' : 'outline'} onClick={() => setFormData(p => ({ ...p, booked_at_padua: true, planning_wedding: false }))}>Yes</Button>
                <Button variant={!formData.booked_at_padua ? 'primary' : 'outline'} onClick={() => setFormData(p => ({ ...p, booked_at_padua: false }))}>No</Button>
              </div>
            </div>

            {!formData.booked_at_padua && (
              <div className="space-y-4 pt-6 border-t border-gray-100">
                <h3 className="text-xl font-medium text-padua-green">Are they planning a wedding?</h3>
                <div className="flex gap-4 justify-center">
                  <Button variant={formData.planning_wedding ? 'primary' : 'outline'} onClick={() => setFormData(p => ({ ...p, planning_wedding: true }))}>Yes</Button>
                  <Button variant={!formData.planning_wedding ? 'primary' : 'outline'} onClick={() => setFormData(p => ({ ...p, planning_wedding: false }))}>No</Button>
                </div>
              </div>
            )}

            {formData.planning_wedding && !formData.booked_at_padua && (
              <div className="space-y-4 pt-6 border-t border-gray-100">
                <h3 className="text-xl font-medium text-padua-green">Tour Status</h3>
                <select name="tour_status" value={formData.tour_status} onChange={handleChange} className="w-full max-w-xs p-4 border border-gray-300 rounded-xl focus:ring-padua-gold focus:border-padua-gold text-center bg-white">
                  <option value="Never Toured">Never Toured</option>
                  <option value="Tour Scheduled">Tour Scheduled</option>
                  <option value="Previously Toured">Previously Toured</option>
                </select>
              </div>
            )}

            <div className="pt-8 flex gap-4">
              <Button variant="outline" className="w-full" onClick={() => setStep(1)}>Back</Button>
              <Button variant="large" className="w-full" onClick={handleSubmit}>Complete Check-In</Button>
            </div>
          </div>
        )}
      </Card>
    </div>
  );
};